import React, { useEffect, useState  } from 'react';
 import{Button} from '@progress/kendo-react-buttons';
import complteImg from '../images/Group4.png';
import pendingImg from '../images/Group5.png';
import imgpdfD from '../images/icon_pdf.png';
import '../Card/card-style.css';
import fantasticSubmitData from '../data/fantasticsubmit.json'
import storage from '../factory/StorageFactory';
import Loading from '../components/Loading';
import service from '../services/ApiService';
import FormContainer from '../components/FormContainer';
import img2 from '../images/appForm.png';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import helper from '../factory/Helper.js';
 

const fsaData = fantasticSubmitData;

 
const NSSubmit = props => {
    const seq1='1', seq2='2', seq3='3', seq0='0';
    const strCompleted = 'Completed', strPending = 'Pending';
 
    const pdfExportComponent = React.useRef(null);
    const container = React.useRef(null);

    const greenTxtColor = {color:'#389A6E'}
    const greyTxtColor = {color:'#828282'}

    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isAllSubmitted,setIsAllSubmitted] = useState(false);
    const [isPureSHFlow, setIsPureSHFlow] = useState(false);
    
    const [authPerArrayLength,setAuthPerArrayLength] = useState(0);

    const [response, setResponse] = useState({
        RefNum:storage.getRefNo(),
        ApplicantDtls:[],
        ApplicantsDtlsMyInfo:{},
        SubmittedApplicants:{
            Applicant1:'false',
            Applicant2:'false',
            Applicant3:'false'
        }
    });
 
    const [appDtls1, setAppDtls1] = useState({});
    const [appDtls2, setAppDtls2] = useState({});
    const [appDtls3, setAppDtls3] = useState({});

    useEffect(() => {
       
        window.scrollTo(0,0);
        getData();
     }, []);

    const getData = () => {
        service.get().then( res => {
            if(res.data.isSucess){
                if(res.data.model.fields.Data === 'Empty') {
                    getPropsData();
                }
                else {
                    setAppDtlsArrayData(res.data.model.fields.request);
                    setResponse(res.data.model.fields.request);
                    setApplicantObjects(res.data.model.fields.request)
                    setIsAllSubmitted(false);
                }
            }
            clearData();
            setIsLoading(false);
        })
        .catch(err => {
            setIsLoading(false);
            clearData();
        })
    }

    const getPropsData = () => {   //parse form preview or resume application 
        if(props.location.state !== undefined) { //not first time

            let resData = props.location.state.responseData? props.location.state.responseData:'';
         
            setIsAllSubmitted(true);
            setResponse(resData);
            setAppDtlsArrayData(resData);
            setApplicantObjects(resData)
            setIsLoading(false);
        }
        else {
            //redirect to error 
        }
    }

    const setAppDtlsArrayData = (resData) => {
        let tempArray = [];
        if(!Array.isArray(resData.ApplicantDtls)){
            setIsPureSHFlow(false);
            tempArray.push(resData.ApplicantDtls)
        }
        for(let i in resData.ApplicantDtls) {
            if(resData.ApplicantDtls[i].ApplicantSeq !== seq0) {
                tempArray.push(resData.ApplicantDtls[i]);
            }

            if(resData.ApplicantDtls[i].Authorised === undefined || resData.ApplicantDtls[i].Authorised === 'true') {
                setIsPureSHFlow(false);
            }
            else {
                setIsPureSHFlow(true);
            }
        }
       
        setAuthPerArrayLength(tempArray.length);
       
    }

    const clearData =()=> {
        if(storage.getStateId() !== null){
            storage.clearAll();
        }
    }

    const setApplicantObjects = (data) => {
        if(Array.isArray(data.ApplicantDtls)){
         
            for(let i in data.ApplicantDtls) {
                if(data.ApplicantDtls[i].ApplicantSeq === seq1) {
                    setAppDtls1(data.ApplicantDtls[i]);
                }
                if(data.ApplicantDtls[i].ApplicantSeq === seq2) {
                    setAppDtls2(data.ApplicantDtls[i]);
                }
                if(data.ApplicantDtls[i].ApplicantSeq === seq3) {
                    setAppDtls3(data.ApplicantDtls[i]);
                }
            }   
        }
        else {
            setAuthPerArrayLength(1);
            if(data.ApplicantDtls.ApplicantSeq === seq1) {
                setAppDtls1(data.ApplicantDtls);
            }
        }
    }

    const printPDF = () => {
        window.print();
    }

    const getProxyUrl = () => {
        const url = helper.getPdfUrl('NSSubmit');
        return url;
    }

    const exportPDFWithMethod = () => {
        let element = container.current || document.body;
        savePDF(element, {
          paperSize: 'auto',
          margin: 5,
          fileName:response.RefNum+'.pdf',
          proxyUrl:getProxyUrl()
        });
      };
    
    const exportPDFWithComponent = () => {
        if (pdfExportComponent.current) {
            pdfExportComponent.current.save();

        }
    };

    const is3APAuthorised = () => {
        if((appDtls1.Authorised === undefined) && (appDtls2.Authorised === undefined) && (appDtls3.Authorised === undefined)) {
            return true;
        }
        else if((appDtls1.Authorised === 'true') && (appDtls2.Authorised === 'true') && (appDtls3.Authorised === 'true')) {
            return true;
        }
        else {
            return false;
        }
    }

    const is2AP1SH = () => {
        if((appDtls1.Authorised === 'true') && (appDtls2.Authorised === 'true') &&  (appDtls3.Authorised === 'false')) {
            return true;
        }
        else if((appDtls1.Authorised === 'true') && (appDtls2.Authorised === 'false') &&  (appDtls3.Authorised === 'true')) {
            return true;
        }
        else {
            return false;
        }
    }

    const is1AP2SH = () => {
        if((appDtls1.Authorised === 'true') && (appDtls2.Authorised === 'false') &&  (appDtls3.Authorised === 'false')) {
            return true;
        }
        else {
            return false;
        }
    }

    const is1AP1SH = () => {
        if((appDtls1.Authorised === 'true') && (appDtls2.Authorised === 'false')) {
            return true;
        }
 
        else {
            return false;
        }
    }

    const is2APAuthorised = () => {
        if((appDtls1.Authorised === undefined || appDtls1.Authorised === 'true') && (appDtls2.Authorised === undefined || appDtls2.Authorised === 'true')) {
            return true;
        }
        else {
            return false;
        }
    }

    if(isLoading) {
        return(
            <Loading  />
        )
    }

    return(  
        <PDFExport ref={pdfExportComponent} paperSize="auto" margin={10} fileName={response.RefNum+'.pdf'}> 
        <div><br/>
        <div className="k-align-items-center">            
            <div className="bgtxt">
                {isAllSubmitted? 
                    'Fantastic! We have received your application.'
                    :
                    'We have received your application.'
                }
            </div> 
            <div className="sbgtxt">
            {isAllSubmitted? 
                <>{'Please look out for your application status update via email.'}</>
                :
                <>
                {!isPureSHFlow? 
                    'Your authorised person(s) will receive an email/ a SMS to complete the application'
                    :
                    'Subsequent person(s) will receive an email/SMS notification to review and complete the online application'
                }
                </>
            }</div>
        </div> 
        
        <div style={{ textAlign: "center", display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap' }} >
          <FormContainer>
            <div>
               {!isAllSubmitted?
                <div className="smTxt"> 
                    {!isPureSHFlow?
                    <div style={{fontSize:"1.2em",fontWeight:'500'}}>
                        {'Thanks! We have received your application.'} 
                    </div>
                    :
                    <div style={{fontSize:"1.2em",fontWeight:'500'}}>
                        {'Submission in Progress'}
                    </div>
                    }
                    <br/>
                    <div><span>{fsaData.cardLabel2.header}</span><span style={{fontWeight:'500'}}>{response.RefNum !==null?response.RefNum:''}</span></div>
                    <div><span>{'Status: '}</span><span style={{fontWeight:'500'}}>{isAllSubmitted? strCompleted: strPending}</span></div>
                </div>
                :
                <div className="smTxt"> 
                    <div style={{fontSize:"1.2em",fontWeight:'500'}}>
                        {'Thanks! We will review your application.'}
                    </div><br/>
                    <div>{'This usually takes around an hour, sometimes up to 2 days.'}</div>
                    <div>{'We will get in touch with you.'}</div>
                    <div style={{paddingTop:'10px'}}>{fsaData.cardLabel.header}<span style={{fontWeight:'500'}}>{response.RefNum}</span></div>
                </div>
                }
                {authPerArrayLength === 3 &&
                <div>
                    {is3APAuthorised() &&
                        <div style={{paddingBottom:'30px',fontWeight:'500',fontSize:"1.1em"}}>{'Authorised Persons'} </div>
                    }
                    {is1AP2SH() &&
                        <div className="row sccbTxtRow">
                            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">        
                                <div style={{paddingBottom:'20px',fontWeight:'500',fontSize:"1.1em"}}>
                                    {'Authorised Person(s)'}
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8"> 
                                <div style={{paddingBottom:'20px',fontWeight:'500',fontSize:"1.1em"}}>
                                    {'Shareholder(s)'}
                                </div>
                            </div>
                        </div>
                    }

                    {is2AP1SH() &&
                        <div className="row sccbTxtRow">
                            <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8">        
                                <div style={{paddingBottom:'20px',fontWeight:'500',fontSize:"1.1em"}}>
                                    {'Authorised Person(s)'}
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4"> 
                                <div style={{paddingBottom:'20px',fontWeight:'500',fontSize:"1.1em"}}>
                                    {'Shareholder(s)'}
                                </div>
                            </div>
                        </div>
                    }

                    <div className="row sccbTxtRow">
                    <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">                        
                        <img className="imgScc2" src={(isAllSubmitted || response.SubmittedApplicants.Applicant1 === 'true')?complteImg:pendingImg} alt="imgScc1"></img><br/><br/>
                        <p className="sccbTxt3h sccbTxt3hgreen" style={(isAllSubmitted ||response.SubmittedApplicants.Applicant1 === 'true')? greenTxtColor: greyTxtColor}>
                            {(isAllSubmitted || response.SubmittedApplicants.Applicant1 === 'true')?strCompleted:strPending}
                        </p>
                        <div className="sccbTxt3" >{appDtls1.Name}</div>
                        <div className="sccbTxt3" >{appDtls1.EmailAdd}</div>
                    </div> 
                
                    <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">                        
                        <img className="imgScc2" src={(isAllSubmitted || response.SubmittedApplicants.Applicant2 === 'true')?complteImg:pendingImg} alt="imgScc2"></img><br/><br/>
                        <p className="sccbTxt3h" style={(isAllSubmitted || response.SubmittedApplicants.Applicant2 === 'true')? greenTxtColor: greyTxtColor}>
                            {(isAllSubmitted || response.SubmittedApplicants.Applicant2 === 'true')?strCompleted:strPending}
                        </p>
                        <div className="sccbTxt3" >{appDtls2.Name}</div>
                        <div className="sccbTxt3" >{appDtls2.EmailAdd}</div>
                    </div> 
 
                    <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">                        
                        <img className="imgScc2" src={(isAllSubmitted || response.SubmittedApplicants.Applicant3 === 'true')?complteImg:pendingImg} alt="imgScc2"></img><br/><br/>
                        <p className="sccbTxt3h" style={(isAllSubmitted || response.SubmittedApplicants.Applicant3 === 'true')? greenTxtColor: greyTxtColor}>
                            {(isAllSubmitted || response.SubmittedApplicants.Applicant3 === 'true')?strCompleted:strPending}
                        </p>
                        <div className="sccbTxt3" >{appDtls3.Name}</div>
                        <div className="sccbTxt3" >{appDtls3.EmailAdd}</div>
                    </div>
                </div>
                </div>}
                {authPerArrayLength === 2 &&
                <div>
                {is2APAuthorised() &&
                    <div style={{paddingBottom:'30px',fontWeight:'500',fontSize:"1.1em"}}>{'Authorised Persons'}</div>
                }
                {is1AP1SH() &&
                    <div className="row sccbTxtRow">
                        <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2"></div>
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">        
                            <div style={{paddingBottom:'20px',fontWeight:'500',fontSize:"1.1em"}}>
                            {'Authorised Person(s)'}
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4"> 
                            <div style={{paddingBottom:'20px',fontWeight:'500',fontSize:"1.1em"}}>
                            {'Shareholder(s)'}
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2"></div>
                    </div>
                }
             
                <div className="row sccbTxtRow">
                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2"></div>
                    <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">                        
                        <img className="imgScc2" src={(isAllSubmitted || response.SubmittedApplicants.Applicant1 === 'true')?complteImg:pendingImg} alt="imgScc1"></img><br/><br/>
                        <p className="sccbTxt3h sccbTxt3hgreen" style={(isAllSubmitted || response.SubmittedApplicants.Applicant1 === 'true')? greenTxtColor: greyTxtColor} >
                            {(isAllSubmitted || response.SubmittedApplicants.Applicant1 === 'true')?strCompleted:strPending}
                        </p>
                        <div className="sccbTxt3" >{appDtls1.Name}</div>
                        <div className="sccbTxt3" >{appDtls1.EmailAdd}</div>
                    </div> 
                  
                    <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">                        
                        <img className="imgScc2" src={(isAllSubmitted || response.SubmittedApplicants.Applicant2 === 'true')?complteImg:pendingImg} alt="imgScc2"></img><br/><br/>
                        <p className="sccbTxt3h" style={(isAllSubmitted || response.SubmittedApplicants.Applicant2 === 'true')? greenTxtColor: greyTxtColor}>
                            {(isAllSubmitted || response.SubmittedApplicants.Applicant2 === 'true')? strCompleted:strPending}
                        </p>
                        <div className="sccbTxt3" >{appDtls2.Name}</div>
                        <div className="sccbTxt3" >{appDtls2.EmailAdd}</div>
                    </div> 
                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2"></div>
                </div>
                </div>}
                {/* {authPerArrayLength === 1 && 
                    <div className="row sccbTxtRow">
                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2"></div>
                    <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8">                        
                        <div style={{textAlign:'center'}}>
                        <img className="imgScc2" src={(isAllSubmitted || response.SubmittedApplicants.Applicant1 === 'true')?complteImg:pendingImg} alt="imgScc1"></img><br/><br/>
                        </div>
                        <p className="sccbTxt3h sccbTxt3hgreen" style={(isAllSubmitted || response.SubmittedApplicants.Applicant1 === 'true')? greenTxtColor: greyTxtColor} >
                            {(isAllSubmitted || response.SubmittedApplicants.Applicant1 === 'true')?strCompleted:strPending}
                        </p>
                        <div className="sccbTxt3" >{appDtls1.Name}</div>
                        <div className="sccbTxt3" >{appDtls1.EmailAdd}</div>
                    </div> 
                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2"></div>
                </div>} */}
            </div> 

            {(isAllSubmitted && authPerArrayLength ===1) &&
            <div>
                <div className="smTxt"> 
                    <div style={{fontSize:"1.2em",fontWeight:'500'}}>{'Thanks! We will review your application.'}</div><br/>
                    <div>{'This usually takes around an hour, sometimes up to 2 days.'}</div>
                    <div>{'We will get in touch with you.'}</div>
                    <div style={{paddingTop:'10px'}}>{fsaData.cardLabel.header}<span style={{fontWeight:'500'}}>{response.RefNum}</span></div>
                </div> 
                <img className="imgScc" src={img2} alt="imgScc"></img>
            </div>}
            <div style={{paddingTop: "20px",paddingBottom:'20px'}}> <hr className="lightgreyPanelLine"/> </div>
            <div className="sccbtMid">
                <Button look="outline" className="btSize2 btLft2" onClick={exportPDFWithMethod}>                                                                                   
                    <img className="img-fluid" src={imgpdfD} alt="imgpdfD"></img>
                    {fsaData.cardLabel.btnSave}
                </Button>                                
                {/* <Button look="outline" className="btSize2 btRht3" onClick={printPDF}>
                    <img className="img-fluid" src={imgPrint} alt="imgPrint"></img>
                    {fsaData.cardLabel.btnPrint}                                   
                </Button> */}
            </div>
            <br/><br/>
          </FormContainer>
        </div>
      </div>
      </PDFExport>
    );
}

export default NSSubmit;